import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

_pushScopeId("data-v-2692af9e");

var _hoisted_1 = {
  class: "li_container"
};
var _hoisted_2 = {
  class: "img--wrapper"
};
var _hoisted_3 = {
  class: "li_info-wrapper"
};

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_image = _resolveComponent("van-image");

  var _component_AddressEditor = _resolveComponent("AddressEditor");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_image, {
    "lazy-load": "",
    width: "88",
    height: "88",
    fit: "cover",
    src: 'https://cdn-fs.touchev.com' + $props.item.coverImgUrl + '!w240',
    alt: ""
  }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", null, _toDisplayString($props.item.title), 1)])]), _createVNode(_component_AddressEditor, {
    item: $props.item,
    saveText: $options.hasAddr ? '重新编辑' : '保存',
    "cancel-text": $options.hasAddr ? '确认' : '取消'
  }, null, 8, ["item", "saveText", "cancel-text"])]);
}